module.exports = __webpack_public_path__ + "img/H4.db782448.png";